module.exports = __webpack_public_path__ + "img/title.b58b79db.png";